<template>
  <v-container class="py-0 px-0 px-md-3">
    <v-row>
      <v-col cols="7" class="py-0 px-0 pl-3">
        <CountryNameWithFlag
          :country-iso-code="countryCode"
          :country-name="countryName"
          style="font-weight:bold;"
        ></CountryNameWithFlag>
      </v-col>
      <v-col
        cols="5"
        class="py-0 text-right px-0 pr-3"
        style="vertical-align: center;"
      >
        <span>
          {{ countriesVisited }}
          {{ declOfNum(countriesVisited, ['поездка', 'поездки', 'поездок']) }}
        </span>
        <v-divider class="mx-0 mx-sm-2 white" vertical></v-divider>
        <span>
          {{ nightsSpent }}
          {{ declOfNum(nightsSpent, ['день', 'дня', 'дней']) }}
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CountryNameWithFlag from '@/components/CountryNameWithFlag'
import { declOfNum } from '@/helpers/helpers.js'

export default {
  components: {
    CountryNameWithFlag
  },

  props: {
    countryName: {
      type: String,
      required: true
    },
    countryCode: {
      type: String
    },

    countriesVisited: {
      type: Number,
      required: true
    },

    nightsSpent: {
      type: Number,
      required: true
    }
  },

  methods: {
    declOfNum
  }
}
</script>

<style></style>
